import './index.scss';
import classnames from 'classnames';
import React from 'react';
const IconInput = ({ leftIcon, rightIcon, children }) => {
    const inputClass = classnames('input-container', {
        'has-left-icon': leftIcon,
        'has-right-icon': rightIcon,
    });
    if (!leftIcon && !rightIcon) {
        return React.createElement("span", { className: inputClass }, children);
    }
    return (React.createElement("span", { className: inputClass },
        leftIcon && React.createElement("span", { className: 'left-icon' }, leftIcon),
        children,
        rightIcon && React.createElement("span", { className: 'right-icon' }, rightIcon)));
};
export default IconInput;
